<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Documentos com Anexos Pendentes'">
          <template v-slot:preview>
            <v-row class="mb-5">
              <v-col cols="4">
                <v-select
                  :items="departamentos"
                  label="Departamento"
                  item-text="caminhoCompleto"
                  item-value="id"
                  v-model="filtro.departamentoID"
                  :rules="[rules.required]"
                  required
                  @change="listaEmpresas()"
                ></v-select>
              </v-col>
              <v-col cols="4">
                <v-select
                  :items="empresas"
                  label="Empresa"
                  :item-text="(item) => item.nome + ' - ' + item.id"
                  item-value="id"
                  v-model="filtro.empresaID"
                  :disabled="filtro.departamentoID == 0"
                  :rules="[rules.required]"
                  required
                  @change="searchDepartamentosTimeOut()"
                ></v-select>
              </v-col>
              <v-col cols="3" align-self="end">
                <v-switch
                  @change="listaEmpresas()"
                  v-model="listarApenasVigentes"
                >
                  <template #label> Ver Apenas Empresas Vigentes </template>
                </v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col align-self="start">
                <v-btn
                  :disabled="
                    filtro.empresaID == 0 || filtro.departamentoID == 0
                  "
                  @click="pesquisar"
                  color="primary"
                  large
                  >Pesquisar</v-btn
                >
              </v-col>
              <!-- <v-col align-self="end" v-if="perfil !== 4" class="text-right">
                <download-excel
                  :ref="'download-relatorio-pendencias'"
                  :data="configExportarPendenciasGeral.pendenciasExportar"
                  :name="configExportarPendenciasGeral.nomeArquivo"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :disabled="loading"
                        v-bind="attrs"
                        v-on="on"
                        color="success"
                        @click.stop="downloadRelatorio()"
                        large
                        >Exportar <v-icon>mdi-file-excel</v-icon></v-btn
                      >
                    </template>
                    <span>Relatório geral de pendencias</span>
                  </v-tooltip>
                </download-excel>
              </v-col> -->
              <v-progress-linear
                v-if="loading"
                indeterminate
                color="indigo"
              ></v-progress-linear>
            </v-row>
            <div v-if="carregando">
              <v-divider></v-divider>
              <v-alert border="left" color="secondary">
                <v-progress-circular
                  indeterminate
                  color="green"
                ></v-progress-circular>
                &nbsp;&nbsp;Estamos carregando as Entidades. Aguarde alguns
                instantes por favor.
              </v-alert>
            </div>

            <v-divider></v-divider>
            <div v-if="entidadesTotal.length == 0 && pesquisado && !carregando">
              <v-alert dense outlined type="info">
                Nenhuma entidade encontrada</v-alert
              >
            </div>
            <div v-if="entidadesTotal.length > 0 && !carregando">
              <v-row class="pt-3">
                <v-col cols="12">
                  <v-alert dense outlined type="success">
                    <strong>{{ entidades.length }}</strong> Entidades
                    Localizadas</v-alert
                  >
                </v-col>
              </v-row>
              <v-row class="pl-3">
                <download-excel
                  :data="configExportar.pendenciasExportar"
                  :name="configExportar.nomeArquivo"
                >
                  <v-btn
                    title="Download"
                    color="success"
                    small
                    :disabled="pendencias.length === 0"
                  >
                    <v-icon class="mr-4" small>fa fa-download</v-icon>
                    Exportar em .XLS
                  </v-btn>
                </download-excel>
              </v-row>
              <v-row v-if="carregandoPendenciasXls">
                <v-col cols="2">
                  <v-progress-linear
                    indeterminate
                    color="indigo"
                  ></v-progress-linear>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="d-flex align-center">
                  <v-menu
                    offset-y
                    close-on-content-click
                    bottom
                    allow-overflow
                    max-height="200px"
                  >
                    <template v-slot:activator="{ on: menu, attrs }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                          <v-btn
                            v-bind="attrs"
                            v-on="{ ...menu, ...tooltip }"
                            text
                          >
                            Ordenar entidades por
                            <v-icon small>mdi-arrow-down</v-icon>
                          </v-btn>
                        </template>
                        <span>Ordenar por</span>
                      </v-tooltip>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="prop in propriedadesOrdenacao"
                        :key="prop"
                        @click="ordenacao(prop)"
                      >
                        <v-list-item-title
                          >{{ prop }}
                          <v-icon small v-if="prop == ordenacaoAtiva.nome">
                            {{
                              ordenacaoAtiva.type == "desc"
                                ? "mdi-arrow-down"
                                : "mdi-arrow-up"
                            }}
                          </v-icon>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="searchEntidades"
                    append-icon="search"
                    label="Pesquisa na Entidade"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-expansion-panels
                inset
                v-if="entidades.length > 0"
                class="mt-5"
              >
                <v-expansion-panel
                  v-for="en in entidades"
                  :key="en.id"
                  @click="listaPendencias(en.id, en.departamentoID)"
                >
                  <v-expansion-panel-header>
                    <v-row>
                      <v-col>
                        <v-icon title="Grupo">{{ en.grupo.icone }}</v-icon>
                      </v-col>
                      <v-col
                        v-for="prop in en.entidadePropriedadeValores"
                        :key="prop.id"
                        cols="3"
                      >
                        <span
                          ><strong
                            >{{ prop.grupoPropriedade.nome }}:</strong
                          ></span
                        >&nbsp;
                        <span>{{ prop.valor }}</span>
                      </v-col>
                      <v-col>
                        <span><strong>Grupo:</strong></span
                        >&nbsp;
                        <span>{{ en.grupo.nome }}</span>
                      </v-col>
                      <v-col>
                        <span><strong>Departamento:</strong></span
                        >&nbsp;
                        <span>{{ en.departamento.nome }}</span>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="6" offset="6">
                        <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Pesquisa de documentos"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="en.pendencias.length == 0">
                      <v-col cols="12">
                        <v-progress-linear
                          indeterminate
                          color="indigo"
                          v-if="carregandoPendencias"
                        ></v-progress-linear>
                        <v-alert dense outlined type="info" v-else>
                          Nenhuma pendência encontrada para essa
                          entidade</v-alert
                        >
                      </v-col>
                    </v-row>
                    <v-data-table
                      v-else
                      :headers="headers"
                      :items="en.pendencias"
                      :search="search"
                      :custom-filter="customFilter"
                      :sort-by.sync="columnName"
                      :sort-desc.sync="isDescending"
                    >
                      <template v-slot:item="{ item, index }">
                        <tr>
                          <td>
                            <v-icon
                              color="success"
                              v-if="item.manual"
                              title="Pendência Criada Manualmente"
                              >far fa-hand-paper</v-icon
                            >
                          </td>
                          <td>{{ item.documento }}</td>
                          <td>{{ item.periodo }}</td>
                          <td>
                            <v-icon
                              color="red"
                              v-if="verificarDocumentoAtrasado(item.periodo)"
                              title="Documento Atrasado"
                              >fas fa-exclamation-triangle</v-icon
                            >
                          </td>
                          <td>
                            <v-chip
                              color="warning"
                              v-if="item.statusPendencia === 2"
                              text-color="white"
                            >
                              Aguardando Arquivos
                            </v-chip>
                            <v-chip
                              color="#d75413"
                              v-if="item.statusPendencia === 3"
                              text-color="white"
                            >
                              Aguardando Validação
                            </v-chip>
                            <v-chip
                              color="success"
                              v-if="item.statusPendencia === 1"
                              text-color="white"
                            >
                              Aprovado
                            </v-chip>
                            <div v-if="item.statusPendencia === 0">
                              <v-row>
                                <v-col
                                  ><v-chip color="error" text-color="white">
                                    Reprovado
                                  </v-chip></v-col
                                >
                              </v-row>
                            </div>
                          </td>
                          <td style="min-width: 150px">
                            <v-row>
                              <v-col>
                                <span>
                                  <v-btn
                                    title="Validar Documentos"
                                    color="cyan"
                                    fab
                                    x-small
                                    dark
                                    @click="uploadOuValidacao(item, index, 2)"
                                    v-if="
                                      item.statusPendencia === 3 &&
                                      verficiarPermissao(4)
                                    "
                                  >
                                    <v-icon>fas fa-images</v-icon>
                                  </v-btn>
                                  <v-btn
                                    title="Validar Documentos"
                                    color="secondary"
                                    fab
                                    x-small
                                    dark
                                    v-else
                                  >
                                    <v-icon>fas fa-images</v-icon>
                                  </v-btn>
                                </span>
                                <v-btn
                                  v-if="
                                    item.registroID == null ||
                                    item.registroID == 0
                                  "
                                  color="secondary"
                                  class="ml-2"
                                  fab
                                  x-small
                                  dark
                                >
                                  <v-icon dark icon> fas fa-eye </v-icon>
                                </v-btn>

                                <v-btn
                                  v-else
                                  color="primary"
                                  class="ml-2"
                                  fab
                                  x-small
                                  dark
                                  title="Exibir Histórico"
                                  @click="abrirHistorico(item.registroID)"
                                >
                                  <v-icon dark icon> fas fa-eye </v-icon>
                                </v-btn>

                                <v-btn
                                  color="success"
                                  ml-2
                                  fab
                                  x-small
                                  dark
                                  class="ml-2"
                                  @click="uploadOuValidacao(item, index, 1)"
                                  v-if="
                                    (item.statusPendencia === 2 ||
                                      item.statusPendencia === 0) &&
                                    verficiarPermissao(5)
                                  "
                                  ><v-icon>fas fa-upload</v-icon></v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  ml-2
                                  fab
                                  x-small
                                  dark
                                  class="ml-2"
                                  v-else
                                  ><v-icon>fas fa-upload</v-icon></v-btn
                                >
                                <v-btn
                                  v-if="
                                    !item.documentoObrigatorio &&
                                    item.statusPendencia !== 1 &&
                                    item.statusPendencia !== 3
                                  "
                                  color="error"
                                  class="ml-2"
                                  fab
                                  x-small
                                  dark
                                  title="Excluir"
                                  @click="
                                    excluirRegistro(
                                      item.registroID,
                                      item.entidadeID,
                                      item.departamentoID,
                                      item.documentoID,
                                      item.periodo
                                    )
                                  "
                                >
                                  <v-icon dark icon>mdi-trash-can</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </template>
        </KTCodePreview>
      </div>
    </div>
    <div class="text-center">
      <modal-dialog-validar
        :acaoModal="acaoModal"
        :arquivoValidacao="arquivoValidacao"
        :cliente="cliente"
        :visualizar="dialog"
        :value="documento"
        :pesquisandoImagens="pesquisandoImagens"
        :loading="saving"
        :anexos="anexos"
        @close="() => (dialog = false)"
        @listaPendencias="listaPendencias"
        @limparPendencias="() => (pendencias = [])"
        @loading="(estado) => (saving = estado)"
      />
      <v-dialog
        v-model="dialogImagem"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialogImagem = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="downloadFile(urlCaminhoExibir)">
                Salvar
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-row class="mt-2" justify="center">
            <img :src="urlCaminhoExibir" />
          </v-row>
        </v-card>
      </v-dialog>
      <modal-dialog-historico
        :dialogHistorico="dialogHistorico"
        :registroSelecionado="registroSelecionado"
        @close="closeHistorico"
        @inativar-registro="inativarRegistro"
      />

      <!-- <v-dialog v-model="dialogHistorico" max-width="90%">
        <v-card>
          <v-card-title>
            <span class="headline">Versões do Registro</span>
          </v-card-title>
          <v-card-text>
            <historico-registro
              :registroSelecionado="registroSelecionado"
              @inativar-registro="
                inativarRegistro(registroSelecionado.entidadeID)
              "
            ></historico-registro>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogHistorico = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <v-dialog
        v-model="dialogPDF"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        width="unset"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="fecharPDF()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                text
                @click="downloadFile(pdfExibir.caminhoVisualizacao)"
              >
                Salvar
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-row class="mt-2" justify="center">
            <!-- <vue-pdf-app
              theme="dark"
              @pages-rendered="pagesRenderedHandler"
              style="height: 84vh; flex: 1; margin: 1%"
              :pdf="pdfExibir.caminhoVisualizacao"
            ></vue-pdf-app> -->
            <vue-pdf-embed
              v-if="dialogPDF"
              :source="pdfExibir.caminhoVisualizacao"
              style="
                height: 100%;
                flex: 1;
                margin-left: 15%;
                margin-right: 15%;
                margin-top: 2%;
                margin-bottom: 2%;
              "
            />
          </v-row>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import "vue-pdf-app/dist/icons/main.css";
// import TelaLoading from "@/views/components/TelaLoading.vue";
import RelatorioService from "@/common/services/http/relatorio.service";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import ModalDialogHistorico from "./componentes/ModalDialogHistorico.vue";
import ModalDialogValidar from "./componentes/ModalDialogValidar.vue";

export default {
  name: "pendencias",
  data() {
    return {
      listarApenasVigentes: true,
      saving: false,
      loading: false,
      acaoModal: 0, // 0 - Sem Ação, 1 - Upload, 2 - Validação
      dialog: false,
      dialogImagem: false,
      dialogHistorico: false,
      dialogPDF: false,
      entidadesTotal: [],
      registroSelecionado: null,
      pendencias: [],
      columnName: "statusPendenciaNome",
      isDescending: true,
      configExportar: {
        pendenciasExportar: [],
        nomeArquivo: "",
      },
      configExportarPendenciasGeral: {
        pendenciasExportar: [],
        nomeArquivo: "",
      },
      ordenacaoAtiva: {
        nome: undefined,
        type: undefined,
      },

      pdfExibir: {},
      anexos: [],
      search: "",
      searchEntidades: "",
      pesquisandoImagens: false,
      urlCaminhoExibir: null,
      headers: [
        { text: "", value: "" },
        { text: "Documento Pendente", value: "documento" },
        { text: "Período", value: "periodo" },
        { text: "", value: "" },
        { text: "Status", value: "statusPendenciaNome" },
        { text: "", value: "" },
      ],
      cliente: {},
      usuario: {},
      perfil: null,
      documento: {
        id: 0,
        status: 0,
        propriedadesEntidade: [],
        nome: "",
        periodo: "",
        grupo: "",
        departamento: "",
        departamentoID: 0,
        empresa: "",
        validadeString: null,
        arquivos: [{ idFront: new Date().getTime(), nome: "", arquivo: {} }],
        tipoDocumento: 0,
        entidade: 0,
        grupoID: 0,
        indice: 0,
        exclusao: null,
        extensoesID: [],
      },
      arquivoValidacao: {
        registroID: 0,
        entidadeID: 0,
        documentoID: 0,
        validado: false,
        observacoes: "",
        periodoMes: "",
        periodoAno: "",
        exclusao: null,
      },
      empresas: [],
      departamentos: [],
      grupos: [],
      filtro: {
        empresaID: 0,
        departamentoID: 0,
        grupoID: 0,
      },
      carregando: false,
      carregandoPendencias: false,
      carregandoPendenciasXls: false,
      pesquisado: false,
      rules: {
        required: (v) => !!v || "Obrigatório",
      },
      entidades: [],
      propriedadesOrdenacao: [],
    };
  },
  components: {
    KTCodePreview,

    VuePdfEmbed,
    ModalDialogHistorico,
    ModalDialogValidar,
  },
  computed: {},
  methods: {
    propriedadeInteligente() {
      const propriedades = [];
      this.entidades.forEach((f) => {
        f.entidadePropriedadeValores.forEach((gp) => {
          propriedades.push(gp.grupoPropriedade.nome);
        });
      });
      this.propriedadesOrdenacao = [...new Set(propriedades)];
    },
    ordenacao(prop) {
      if (this.ordenacaoAtiva.nome != prop) {
        this.ordenacaoAtiva.nome = prop;
        this.ordenacaoAtiva.type = undefined;
      }
      this.ordenacaoAtiva.type =
        this.ordenacaoAtiva.type == "asc" ? "desc" : "asc";

      if (this.ordenacaoAtiva == prop) {
        this.entidades = this.entidades.reverse();
        return;
      }
      this.entidades = this.entidades
        .sort((a, b) => this.ordenacaoPorProp(a, b, prop))
        .slice();
      if (this.ordenacaoAtiva.type == "desc") {
        this.entidades = this.entidades.reverse();
      }
    },
    ordenacaoPorProp(a, b, prop) {
      const nomeA = a.entidadePropriedadeValores
        .find((p) => p.grupoPropriedade.nome == prop)
        ?.valor.trim();
      const nomeB = b.entidadePropriedadeValores
        .find((p) => p.grupoPropriedade.nome == prop)
        ?.valor.trim();

      if (!nomeA && !nomeB) return 0;
      if (!nomeA) return 1;
      if (!nomeB) return -1;
      if (nomeA > nomeB) return 1;
      if (nomeA < nomeB) return -1;
      return 0;
    },
    ordenacaoPorDocumento(a, b) {
      const documentoA = (
        a.entidadePropriedadeValores.find(
          (p) => p.grupoPropriedade.nome == "CNPJ"
        ) ??
        a.entidadePropriedadeValores.find(
          (p) => p.grupoPropriedade.nome == "CPF"
        )
      ).valor?.trim();
      const documentoB = (
        b.entidadePropriedadeValores.find(
          (p) => p.grupoPropriedade.nome == "CNPJ"
        ) ??
        b.entidadePropriedadeValores.find(
          (p) => p.grupoPropriedade.nome == "CPF"
        )
      ).valor?.trim();

      if (!documentoA && !documentoB) return 0;
      if (!documentoA) return 1;
      if (!documentoB) return -1;
      if (documentoA > documentoB) return 1;
      if (documentoA < documentoB) return -1;
      return 0;
    },
    closeHistorico() {
      this.dialogHistorico = false;
      this.registroSelecionado = null;
    },
    adicionarMascara(item, valor) {
      switch (item) {
        case 1:
          return this.cpf(valor);
        case 2:
          return this.cnpj(valor);
        default:
          return valor;
      }
    },
    cnpj(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/, "$1.$2");
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
      v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
      v = v.replace(/(\d{4})(\d)/, "$1-$2");
      return v;
    },

    cpf(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/(\d{3})(\d)/, "$1.$2");
      v = v.replace(/(\d{3})(\d)/, "$1.$2");
      v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      return v;
    },

    pagesRenderedHandler(pdfApp) {
      setTimeout(() => {
        pdfApp.pdfViewer.currentScaleValue = 1; // 100%;
        // pdfApp.pdfViewer.currentScaleValue = 0.2 // 20%;
        // pdfApp.pdfViewer.currentScaleValue = "page-actual"
        // pdfApp.pdfViewer.currentScaleValue = "page-width"
        // pdfApp.pdfViewer.currentScaleValue = "page-height"
        // pdfApp.pdfViewer.currentScaleValue = "page-fit"
        // pdfApp.pdfViewer.currentScaleValue = "auto"
      });
    },
    async downloadRelatorio() {
      this.loading = true;
      let config = await RelatorioService.relatorioPendencias({
        clienteID: this.cliente.id,
      });

      if (config) {
        this.configExportarPendenciasGeral = config;
        setTimeout(() => {
          this.loading = false;
          this.$refs["download-relatorio-pendencias"].$el.click();
        }, 1000);
      }
    },
    filtrarEntidades(searchEntidades) {
      if (searchEntidades == "") this.entidades = this.entidadesTotal;
      else {
        let entidadesFiltradas = [];
        this.entidades = [];
        let search = searchEntidades.toLowerCase();
        this.entidadesTotal.forEach((x) => {
          x.entidadePropriedadeValores.forEach((prop) => {
            if (
              prop.valor.toString().toLowerCase().includes(search) &&
              !entidadesFiltradas.find((t) => t.id == x.id)
            ) {
              entidadesFiltradas.push(x);
            }
          });
        });

        this.entidades = entidadesFiltradas;
      }
    },
    async listaEntidades() {
      let entidades = [];
      this.carregando = true;

      const { data: result } = await ApiService.get(
        "entidade",
        `listar/com-pendencias/empresa/${this.filtro.empresaID}/departamento/${this.filtro.departamentoID}`
      );

      if (result.success && result.data != null) {
        entidades = result.data;

        entidades.forEach((x) => {
          x.pendencias = [];
          x.entidadePropriedadeValores.forEach((prop) => {
            if (prop.grupoPropriedade.propriedadeInteligenteID) {
              prop.valor = this.adicionarMascara(
                prop.grupoPropriedade.propriedadeInteligenteID,
                prop.valor
              );
            }
          });
        });
      } else SweetAlert.sweetAlertError(result.errors);

      this.entidades = entidades;
      this.entidadesTotal = entidades;
      this.carregando = false;
      this.pesquisado = true;
      this.propriedadeInteligente();
      this.listaExcelPendencias();
    },
    async listaEmpresas() {
      this.filtro.empresaID = 0;
      let empresas = [];

      if (this.usuario.usuario.tipoUsuario === 4) {
        const { data: result } = await ApiService.get(
          "empresa/getbyusuarioedepartamentoidsimples/" +
            this.usuario.usuario.id +
            "/" +
            this.filtro.departamentoID
        );

        if (result.success && result.data != null) {
          if (this.listarApenasVigentes)
            empresas = result.data.filter((x) => x.dataVigenciaFim == null);
          else empresas = result.data;
        } else SweetAlert.sweetAlertError(result.errors);
      } else {
        const { data: result } = await ApiService.get(
          "empresa/getbydepartamentoidsimples/" + this.filtro.departamentoID
        );

        if (result.success && result.data != null) {
          if (this.listarApenasVigentes)
            empresas = result.data.filter((x) => x.dataVigenciaFim == null);
          else empresas = result.data;
        } else SweetAlert.sweetAlertError(result.errors);
      }

      this.empresas = empresas;
    },

    async listaDepartamentos() {
      let departamentos = [];

      const { data: result } = await ApiService.get(
        "departamento/getbyclienteid/" + this.cliente.id
      );

      if (result.success) departamentos = result.data;
      else SweetAlert.sweetAlertError(result.errors);

      this.departamentos = departamentos;
    },

    async abrirHistorico(registroID) {
      this.registroSelecionado = null;

      const { data: result } = await ApiService.get(
        "Registro/GetRegistroFullEntityById/" +
          registroID +
          "/" +
          this.usuario.usuario.id
      );

      if (result.success) {
        this.registroSelecionado = result.data;
        this.dialogHistorico = true;
      } else SweetAlert.sweetAlertError(result.errors);
    },

    // async listaDepartamentos() {
    //   this.departamentos = [];
    //   this.filtro.departamentoID = 0;
    //   this.filtro.grupoID = 0;

    //   const { data: result } = await ApiService.get(
    //     "departamento/GetByDepartamentoPorEmpresaID/" + this.filtro.empresaID
    //   );

    //   if (result.success) this.departamentos = result.data;
    //   else SweetAlert.sweetAlertError(result.errors);
    // },

    searchDepartamentosTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {}, 500);
    },

    async listaGrupos() {
      this.grupos = [];
      this.filtro.grupoID = 0;

      const { data: result } = await ApiService.get(
        "grupo/getByDepartamentoID/" + this.filtro.departamentoID
      );

      if (result.success) this.grupos = result.data;
      else SweetAlert.sweetAlertError(result.errors);
    },
    customSort(a, b) {
      return (
        a.statusPendencia < b.statusPendencia ||
        b.statusPendencia == 0 ||
        a.statusPendencia == 0
      );
    },
    listaPendencias(entidadeID, departamentoID = null) {
      let entidade = this.entidades.find((x) => {
        return x.id === entidadeID;
      });

      entidade.pendencias = [];
      departamentoID = departamentoID
        ? departamentoID
        : this.filtro.departamentoID;

      if (entidade.pendencias.length === 0) {
        this.carregandoPendencias = true;
        return new Promise((resolve) => {
          ApiService.get("registro", "ListarPendencias", {
            empresaID: this.filtro.empresaID,
            departamentoID,
            grupoID: null,
            entidadeID,
            carregarPropriedades: true,
          }).then(({ data }) => {
            if (data.success) {
              resolve(data);
              this.entidades.find((x) => x.id === entidadeID).pendencias =
                data.data
                  .filter((x) => {
                    return x.statusPendencia !== 1;
                  })
                  .sort(this.customSort);
              //this.listaExcelPendencias();
              this.carregandoPendencias = false;

              // this.prepararPendenciasExportar();
            } else SweetAlert.sweetAlertError(data.errors);
          });
        });
      }
    },

    listaExcelPendencias() {
      this.carregandoPendenciasXls = true;

      return new Promise((resolve) => {
        ApiService.get("registro", "ListarPendencias", {
          empresaID: this.filtro.empresaID,
          departamentoID: this.filtro.departamentoID,
          grupoID: null,
          carregarPropriedades: true,
          departamentosInferiores: true,
        }).then(({ data }) => {
          if (data.success) {
            resolve(data);
            this.pendencias = data.data.filter((x) => {
              return x.statusPendencia !== 1;
            });
            this.carregandoPendenciasXls = false;
            this.prepararPendenciasExportar();
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    customFilter(value, search, item) {
      if (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
      ) {
        return true;
      }

      if (
        item.statusPendenciaNome
          .toString()
          .toLowerCase()
          .indexOf(search.toLowerCase()) !== -1
      ) {
        return true;
      }

      for (let index = 0; index < item.propriedadesEntidade.length; index++) {
        const propriedade = item.propriedadesEntidade[index];

        if (
          propriedade.valor
            .toString()
            .toLowerCase()
            .indexOf(search.toLowerCase()) !== -1
        ) {
          return true;
        }

        if (
          propriedade.nome
            .toString()
            .toLowerCase()
            .indexOf(search.toLowerCase()) !== -1
        ) {
          return true;
        }
      }

      return false;
    },

    prepararPendenciasExportar() {
      const pendenciasExportar = this.pendencias.map((p) => {
        return {
          Entidade: p.propriedadesEntidade
            .map((pe) =>
              pe.propriedadeInteligenteID
                ? `${pe.nome}: ${this.adicionarMascara(
                    pe.propriedadeInteligenteID,
                    pe.valor
                  )}`
                : `${pe.nome}: ${pe.valor}`
            )
            .join(", "),
          "Documento Pendente": p.documento,
          Período: p.periodo,
          Status: p.statusPendenciaNome,
          Grupo: p.grupo,
          Departamento: p.departamento,
          Empresa: p.empresa,
        };
      });

      this.configExportar.pendenciasExportar = pendenciasExportar;
      this.configExportar.nomeArquivo = `Pendencias-${Date.now()}`;
    },

    validacao(id) {
      this.$router.push({
        name: "validacao",
        params: { entidadeid: id },
      });
    },
    inativarRegistro(entidade) {
      this.dialogHistorico = false;
      SweetAlert.sweetAlertSuccess("Registro removido com sucesso!", 2);
      this.listaPendencias(
        entidade,
        this.entidades.find((x) => x.id == entidade).departamentoID
      );
    },
    pesquisar() {
      this.pendencias = [];
      this.entidades = [];
      this.listaEntidades();
      // this.listaPendencias();
    },

    novoArquivo() {
      this.documento.arquivos.push({
        idFront: new Date().getTime(),
        nome: "",
        arquivo: {},
      });
    },

    excluirArquivo(index) {
      this.documento.arquivos.splice(index, 1);
    },
    async verificarDuplicidade(item) {
      const { data: result } = await ApiService.get(
        "arquivo",
        "verificar-duplicidade",
        {
          EntidadeID: item.entidadeID,
          DocumentoID: item.documentoID,
          Periodo: item.periodo,
        }
      );

      return result;
    },

    async uploadOuValidacao(item, i, acao) {
      let verificacao = await this.verificarDuplicidade(item);

      if (!verificacao.success && acao === 1) {
        SweetAlert.sweetAlertError(verificacao.errors);

        await this.listaPendencias(item.entidadeID, item.departamentoID);
      } else {
        this.documento.obrigatorio = item.documentoObrigatorio;
        this.documento.id = item.documentoID;
        this.documento.status = item.statusPendencia;
        this.documento.propriedadesEntidade = item.propriedadesEntidade;
        this.documento.nome = item.documento;
        this.documento.periodo = item.periodo;
        this.documento.grupo = item.grupo;
        this.documento.departamento = item.departamento;
        this.documento.departamentoID = item.departamentoID;
        this.documento.empresa = item.empresa;
        this.documento.tipoDocumento = item.tipoDocumentoID;
        this.documento.entidade = item.entidadeID;
        this.documento.grupoID = item.grupoID;
        this.documento.registroID = item.registroID ? item.registroID : 0;
        this.indice = i;
        this.documento.extensoesID = item.extensoesID;

        this.documento.validadeString = item.validadeString;
        this.documento.arquivos = [
          { idFront: new Date().getTime(), nome: "", arquivo: {} },
        ];

        await this.buscarRegistroVersao();

        this.acaoModal = acao;

        if (acao === 2) {
          this.carregarImagens();

          this.arquivoValidacao.registroID = item.registroID;
          this.arquivoValidacao.entidadeID = item.entidadeID;
          this.arquivoValidacao.documentoID = item.documentoID;
          this.arquivoValidacao.periodoMes = item.periodo.split("/")[0];
          this.arquivoValidacao.periodoAno = item.periodo.split("/")[1];
          this.arquivoValidacao.observacoes = "";
          this.arquivoValidacao.exclusao = this.documento.exclusao;
        }

        this.dialog = true;
      }
    },

    setFiles(event) {
      if (!this.verificar(event.target.value)) {
        Swal.fire({
          position: "center",
          title: "Tipo de arquivo não permitido",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
        this.excluirArquivo(event.target.dataset.indexarq);
        this.documento.arquivos.push({
          idFront: new Date().getTime(),
          nome: "",
          arquivo: {},
        });
      } else {
        this.documento.arquivos[event.target.dataset.indexarq].arquivo =
          event.target.files;
      }
    },
    verificar(value) {
      value = value.toLowerCase();

      return (
        value.includes(".pdf") ||
        value.includes(".psd") ||
        value.includes(".tiff") ||
        value.includes(".png") ||
        value.includes(".jpeg") ||
        value.includes(".jpg") ||
        value.includes(".bmp") ||
        value.includes(".webp")
      );
    },
    async sincronizar() {
      let self = this;
      this.saving = true;
      let hoje = Date.now();
      let dataAtual = new Date(hoje);
      dataAtual.setHours(0, 0, 0, 0);
      let dataValidade = null;

      if (this.documento.validadeString) {
        let d = this.documento.validadeString.split("-");
        let dataVal = new Date(d[0], d[1] - 1, d[2]);
        dataValidade = dataVal;
      }

      if (
        this.documento.tipoDocumentoID === 4 &&
        (this.documento.validadeString == null ||
          this.documento.validadeString == "")
      ) {
        const resposta = await Swal.fire({
          position: "center",
          title: "A data de validade não foi preenchida",
          icon: "warning",
          showConfirmButton: false,
          timer: 1500,
        });
        this.saving = false;
        if (!resposta.isConfirmed) {
          return;
        }
      } else if (
        this.documento.tipoDocumentoID !== 4 &&
        this.documento.validadeString == ""
      )
        this.documento.validadeString = null;

      if (dataValidade != null && dataValidade <= dataAtual) {
        const resposta = await Swal.fire({
          position: "center",
          title: "A data de validade deve ser maior do que a data atual",
          icon: "warning",
          showConfirmButton: false,
          timer: 1500,
        });
        this.saving = false;
        if (!resposta.isConfirmed) {
          return;
        }
      }

      let erro = false;
      let formData = new FormData();

      formData.append("entidadeID", this.documento.entidade);
      formData.append("documentoID", this.documento.id);
      formData.append("grupoID", this.documento.grupoID);
      formData.append("clienteID", this.cliente.id);
      formData.append("mes", this.documento.periodo.split("/")[0]);
      formData.append("ano", this.documento.periodo.split("/")[1]);
      formData.append("dataValidade", this.documento.validadeString);
      formData.append("registroID", this.documento.registroID);

      for (let i = 0; i < this.documento.arquivos.length; i++) {
        const arq = this.documento.arquivos[i];
        formData.append("arquivos", arq.arquivo[0]);
      }

      if (!erro) {
        const { data: result } = await ApiService.postFormData(
          "arquivo/upload/",
          formData
        );

        if (!result.success) {
          erro = true;
        } else {
          this.documento.registroID = result.data;
        }
      }

      this.saving = false;
      if (!erro) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Arquivos Sincronizados com Sucesso!",
          showConfirmButton: false,
          timer: 1500,
        }).then(function () {
          self.dialog = false;
          self.pendencias = [];
          self.listaPendencias(
            self.documento.entidade,
            self.documento.departamentoID
          );
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Ocorreu um erro interno",
        });
      }
    },

    downloadFile(url) {
      window.open(url);
    },

    exibirImagem(url) {
      if (!url) {
        this.dialogImagem = false;
        return;
      }

      this.urlCaminhoExibir = url;
      this.dialogImagem = true;
    },

    exibirPDF(pdf) {
      if (!pdf) {
        this.dialogPDF = false;
        return;
      }

      this.pdfExibir = pdf;
      this.dialogPDF = true;
    },

    fecharPDF() {
      this.pdfExibir = {};
      this.dialogPDF = false;
    },

    reprovar() {
      let self = this;
      this.arquivoValidacao.validado = false;
      this.arquivoValidacao.clienteID = this.cliente.id;

      if (this.arquivoValidacao.observacoes == "") {
        SweetAlert.sweetAlertError([
          "A observação é obrigatória para a reprovação",
        ]);

        return;
      }

      Swal.fire({
        title: "Tem certeza que deseja REPROVAR esse Documento?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode REPROVAR!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("arquivo/validar/", self.arquivoValidacao).then(
              ({ data }) => {
                if (data.success) {
                  resolve(data);

                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Documento Reprovado com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(function () {
                    self.dialog = false;
                    self.pendencias = [];
                    self.listaPendencias(self.arquivoValidacao.entidadeID);
                  });
                } else SweetAlert.sweetAlertError(data.errors);
              }
            );
          });
        }
      });
    },

    aprovar() {
      let self = this;
      this.arquivoValidacao.validado = true;

      Swal.fire({
        title: "Tem certeza que deseja APROVAR esse Documento?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode APROVAR!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("arquivo/validar/", self.arquivoValidacao).then(
              ({ data }) => {
                resolve(data);

                if (data.success) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Documento Aprovado com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(function () {
                    self.dialog = false;
                    self.pendencias = [];
                    self.listaPendencias(self.arquivoValidacao.entidadeID);
                  });
                } else {
                  Swal.fire({
                    position: "center",
                    icon: "error",
                    title:
                      data.errors.length > 0
                        ? data.errors.join(", ")
                        : "Ocorreu um erro inesperado",
                  });
                }
              }
            );
          });
        }
      });
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    carregarImagens() {
      this.pesquisandoImagens = true;
      this.anexos = [];

      return new Promise((resolve) => {
        ApiService.get(
          // "registroimagem/getbyentidadedocumentoid/" +
          //   this.documento.entidade +
          //   "/" +
          //   this.documento.id +
          //   "/" +
          //   this.documento.periodo.split("/")[0] +
          //   "/" +
          //   this.documento.periodo.split("/")[1]
            `registroimagem/GetByRegistroId/${this.documento.registroID}`
        ).then(({ data }) => {
          if (data.success) {
            resolve(data);

            this.anexos = data.data;
          } else {
            SweetAlert.sweetAlertError(data.errors);
          }

          this.pesquisandoImagens = false;
        });
      });
    },

    popularFiltroPendencias() {
      const filtrosPendencias = {
        empresaID: this.filtro.empresaID,
        departamentoID: this.filtro.departamentoID,
        grupoID: null,
      };

      sessionStorage.setItem(
        "filtrosPendencias",
        JSON.stringify(filtrosPendencias)
      );
    },

    async preencherFiltrosAutomaticamente() {
      const filtrosPendencias = JSON.parse(
        sessionStorage.getItem("filtrosPendencias")
      );

      const empresaID = filtrosPendencias.empresaID;
      const departamentoID = filtrosPendencias.empresaID;

      await this.listaDepartamentos();

      this.filtro.departamentoID = departamentoID;

      await this.listaEmpresas();

      this.filtro.empresaID = empresaID;

      // await this.listaGrupos();

      // this.filtro.grupoID = grupoID;

      await this.listaEntidades();
      // await this.listaPendencias();
    },
    verficiarPermissao(permissoes) {
      return PermissoesService.verificarAcesso(Modulo.Arquivo, permissoes);
    },
    verificarDocumentoAtrasado(periodo) {
      let mesAtual = new Date().getMonth() + 1;
      let anoAtual = new Date().getFullYear().toString().slice(-2);
      let [mes, ano] = periodo.split("/");

      return mes < mesAtual || ano < anoAtual;
    },
    montarData(data) {
      let [ano, mes, dia] = data.split("-");

      return `${dia}/${mes}/${ano}`;
    },

    excluirRegistro(id, entidadeId, departamentoId, documentoId, periodo) {
      let self = this;
      Swal.fire({
        title: "Tem certeza que deseja solicitar a exclusão dessa pendência?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode excluir!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.post("registro/solicitarexclusao/" + (id ? id : 0), {
              entidadeId: entidadeId,
              documentoId: documentoId,
              periodo: periodo,
            }).then(({ data }) => {
              if (data.success) {
                resolve(data);

                if (data.success === true) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Solicitação de exclusão feita com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(function () {
                    self.listaPendencias(entidadeId, departamentoId);
                  });
                }
              } else SweetAlert.sweetAlertError(data.errors);
            });
          });
        }
      });
    },

    async buscarRegistroVersao() {
      return new Promise((resolve) => {
        ApiService.get(
          "/RegistroVersao/listar/registro/" + this.documento.registroID
        ).then(({ data }) => {
          if (data.success) {
            resolve(data);
            if (data.data.length > 0) {
              this.documento.exclusao = this.documento.exclusao =
                data.data[data.data.length - 1].exclusao;
            }
          } else {
            SweetAlert.sweetAlertError(data.errors);
          }
        });
      });
    },
  },
  watch: {
    searchEntidades(query) {
      this.filtrarEntidades(query);
    },
  },
  mounted() {
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.usuario = JSON.parse(window.localStorage.getItem("usuario"));

    if (
      JSON.parse(window.localStorage.getItem("usuario")).usuario != undefined
    ) {
      this.perfil = JSON.parse(
        window.localStorage.getItem("usuario")
      ).usuario.tipoUsuario;
    }

    const filtrosPendencias = sessionStorage.getItem("filtrosPendencias")
      ? JSON.parse(sessionStorage.getItem("filtrosPendencias"))
      : null;

    if (filtrosPendencias) {
      this.preencherFiltrosAutomaticamente();
    } else {
      this.listaDepartamentos();
      this.listaEmpresas();
    }
  },
  created() {
    if (
      !PermissoesService.verificarAcesso(
        Modulo.Pendencia,
        Permissoes.Visualizar
      )
    ) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
